(function () {
  'use strict';

  function survey(id, brand) {
    return {
      id: id,
      title: brand + ' Post-Purchase Survey',
      submitLabel: 'Send',
      thankYouTitle: 'Thank you!',
      thankYou: 'Your feedback genuinely helps us improve. If you opted into our UGC program, keep an eye on your inbox!',
      fields: [
        { key: 'satisfaction', type: 'rating', scale: 5,
          label: 'How satisfied are you with your recent purchase from ' + brand + '?',
          help: '1 = Very Dissatisfied, 5 = Very Satisfied' },
        { key: 'improve', type: 'longtext', label: 'What could we improve?',
          showIf: 'satisfaction <= 3' },
        { key: 'encouraged', type: 'select',
          label: 'What would have encouraged you to complete your purchase?',
          options: ['Lower price or discount', 'Free shipping', 'More customer reviews', 'Faster delivery'] },
        { key: 'checkout_reason', type: 'select',
          label: "If you considered purchasing but didn't complete checkout, what was the main reason?",
          options: ['Was having a hard time navigating the website', 'The price was too expensive',
                    'The order and checkout process were confusing', 'Not enough product reviews or information',
                    "I wasn't ready to buy yet"] },
        { key: 'like_most', type: 'select',
          label: 'What do you like most about the product you purchased?',
          options: ['Durability & Quality', 'Performance & Effectiveness', 'Price & Value', 'Ease of Use'] },
        { key: 'ugc_interest', type: 'select', required: true,
          label: 'Would you be interested in sharing a photo or video of your purchase for a small gift or discount?',
          options: ["Yes! I'd love to share my experience", 'Maybe, tell me more', 'No, not interested'] },
        { key: 'email', type: 'email', required: true,
          label: "What's your email address?",
          help: "We'll use it to follow up with you regarding our UGC program.",
          showIf: "ugc_interest != 'No, not interested'" },
        /* Asked ONLY when the post-purchase link did not already carry ?order=,
           so anyone arriving from the email never sees it. */
        { key: 'order', type: 'shorttext', skipIfContext: 'order',
          label: 'What is your order number?',
          help: 'Optional. It lets us match your feedback to your order.' }
      ]
    };
  }

  window.MX_FORM_CONFIGS = {
    'survey-apv': survey('survey-apv', 'Aqua Pro Vac'),
    'survey-eqm': survey('survey-eqm', 'EquipMaxx'),
    'survey-gpv': survey('survey-gpv', 'GutterProVac'),

    'gpv-startup-marketing': {
      id: 'gpv-startup-marketing',
      title: 'GPV Startup Marketing Form',
      submitLabel: 'Submit',
      thankYouTitle: 'All set!',
      thankYou: "Thanks — our team will start on your marketing materials and reach out if we need anything.",
      fields: [
        { key: 'order_number', type: 'shorttext', required: true,
          label: 'What is your order number?',
          help: 'You can find this in your invoice or shipping confirmation email.' },

        { key: 'design_choice', type: 'image-select', columns: 3, required: true,
          label: 'Would you like to choose one of our pre-made designs or provide your custom business colors?',
          help: 'Pick a pre-made template, or choose custom to use your business colors.',
          options: [
            { value: 'design-1',      label: 'TODO(BIA/RENEE): name design 1', image: 'https://images.typeform.com/images/vTY9bAuSeXkA' },
            { value: 'design-2',      label: 'TODO(BIA/RENEE): name design 2', image: 'https://images.typeform.com/images/uL4KSqv9GZSR' },
            { value: 'design-3',      label: 'TODO(BIA/RENEE): name design 3', image: 'https://images.typeform.com/images/6DLRYMZ3H98m' },
            { value: 'design-4',      label: 'TODO(BIA/RENEE): name design 4', image: 'https://images.typeform.com/images/RH53nRaKBAtd' },
            { value: 'custom-colors', label: 'TODO(BIA/RENEE): confirm this is the custom-colors tile', image: 'https://images.typeform.com/images/CTHaP5TXqfYH' }
          ] },

        { key: 'custom_colors', type: 'longtext',
          label: 'What custom colors would you like for your marketing materials?',
          help: 'Provide two hex color codes and note which is the main color and which is the accent (e.g., #FFFFFF for white).',
          showIf: "design_choice == 'custom-colors'" },

        { key: 'contact', type: 'group',
          label: 'Provide your contact details, including your company name.',
          inputs: [
            { key: 'first_name',   label: 'First name',   type: 'text',  required: true },
            { key: 'last_name',    label: 'Last name',    type: 'text',  required: true },
            { key: 'company_name', label: 'Company name', type: 'text',  required: true },
            { key: 'phone',        label: 'Phone number', type: 'tel' },
            { key: 'contact_email', label: 'Email',       type: 'email', required: true }
          ] },

        { key: 'address', type: 'group',
          label: 'What is your company address?',
          help: 'So customers know where to find you.',
          inputs: [
            { key: 'addr_line1', label: 'Address line 1', type: 'text', required: true },
            { key: 'addr_line2', label: 'Address line 2', type: 'text' },
            { key: 'addr_city',  label: 'City',           type: 'text', required: true },
            { key: 'addr_state', label: 'State / Province', type: 'text', required: true },
            { key: 'addr_zip',   label: 'ZIP / Postal code', type: 'text', required: true }
          ] },

        { key: 'company_website', type: 'url',
          label: 'What is your company website?',
          help: 'So customers can easily find you online.' },

        { key: 'logo', type: 'file', required: true, accept: '.png,.svg',
          label: 'Please provide your company logo.',
          help: 'A clear, high-quality image (at least 500x500px) in .png or .svg format with a transparent background.' },

        { key: 'brand_statements', type: 'longtext',
          label: 'Please provide your 3 main brand statements or service mottos.',
          help: 'Three short, impactful statements. Examples: "Clear Gutters, Safe Homes." / "Clean Gutters, Every Season." / "Reliable Gutter Care."' },

        { key: 'about_us', type: 'longtext',
          label: 'Please provide an "About Us" description for your company.',
          help: "A brief description highlighting your company's mission and values." },

        { key: 'why_choose', type: 'longtext',
          label: 'Why should customers choose your company?',
          help: 'A short explanation of what sets your company apart.' },

        { key: 'main_features', type: 'longtext',
          label: 'What are the 3 main features you give to your customers?',
          help: 'Examples: Expert technicians / High-quality service / Affordable prices' },

        { key: 'services', type: 'select', multiple: true, required: true,
          label: 'What services do you offer to your customers? (Select all that apply)',
          options: ['Softwash Roof Cleaning', 'Window Cleaning', 'Solar Panel Cleaning', 'Gutter Cleaning',
                    'Gutter Brightening', 'Hard Surface Cleaning', 'Pressure Washing', 'Lawn Care'] },

        { key: 'qr_link', type: 'url',
          label: 'What is your preferred link to generate into a QR code?',
          help: 'Your website, social media page, or any other link you want on your materials.' },

        { key: 'discounts', type: 'longtext',
          label: 'Do you offer any special discounts for new customers?',
          help: "If yes, we'll highlight them in your marketing materials." }
      ]
    }
  };
})();
